"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRequest = void 0;
exports.handleErrors = handleErrors;
const Sentry = __importStar(require("@sentry/react"));
const snap_ui_1 = require("@teamsnap/snap-ui");
const api_1 = require("core/api");
const React = __importStar(require("react"));
async function handleErrors(call, customErrorHandler) {
    try {
        const data = await call();
        return { data, error: null, ok: true };
        // eslint-disable-next-line
    }
    catch (e) {
        let responseError;
        if (e instanceof api_1.ApiError || e.body) {
            responseError = {
                data: null,
                error: {
                    status: e.status,
                    detail: e.body?.detail || 'An error occurred',
                    title: e.body?.title,
                    extensions: e.body?.extensions,
                },
            };
        }
        else {
            responseError = {
                data: null,
                error: { detail: 'An error occurred' },
            };
        }
        if (customErrorHandler) {
            customErrorHandler(e, responseError);
        }
        return responseError;
    }
}
const useRequest = () => {
    const { toast } = (0, snap_ui_1.useToast)();
    const [error, setError] = React.useState(null);
    const [data, setData] = React.useState(null);
    const [isProcessing, setIsProcessing] = React.useState(false);
    const makeRequest = async (fn, successMessage, config) => {
        setIsProcessing(true);
        const { data, error, ok } = await handleErrors(fn, config?.customErrorHandler);
        setIsProcessing(false);
        if (error) {
            setError(error);
            if (error?.detail) {
                toast({
                    variant: 'negative',
                    title: error.detail || 'An error occurred',
                });
            }
        }
        if (data) {
            setData(data);
            successMessage &&
                toast({
                    variant: 'success',
                    title: successMessage,
                });
        }
        return { data, error, ok };
    };
    React.useEffect(() => {
        if (error)
            Sentry.captureException(new Error('useRequest reponse error'), {
                extra: error,
                tags: { onboarding: 'stripe' },
            });
    }, [error]);
    return {
        makeRequest,
        error,
        data,
        isProcessing,
    };
};
exports.useRequest = useRequest;
